module.exports = __webpack_public_path__ + "img/auth4.96cc968d.png";